angular.module('portal.i18n').run([
    'gettextCatalog',
    function(gettextCatalog) {
        /* jshint -W100 */
        gettextCatalog.setStrings('es', {});
        /* jshint +W100 */
    }
]);
